<template>

	<div id="content" class="content join join_done">
		<div class="container">

			<div class="page-title">
				<h2 class="tit">NAVER 로그인 진행중</h2>
				<p class="sub-tit">NAVER 인증이 진행중입니다. 잠시만 기다려 주세요.</p>
				<input class="inp-id" type="text" id="deviceToken" v-show="LOCAL === 'localhost'" placeholder="장치 토큰" readonly="readonly">
			</div>

		</div>
	</div>

</template>

<script>

import $ from 'jquery'
import webUtils from "@/commons/utils/web.utils";

export default {
	name: "naverIOSReturn",
	data() {
		return {
			LOCAL: location.hostname,
		}
	},
	created() {
		var self = this;
		let vue = this

		if (this.APIs.BASE_URL.indexOf('localhost') !== -1) {
			// 동적으로 현재 포트 사용
			self.APIs.KAKAO_IOS_LOGIN_RETURN = location.origin + '/member/sns/naverIOSReturn'
		}

		let coCode = (location.origin + location.pathname)
			.split(
				this.$router.options.routes
					.map(e => e.children)
					.flat()
					.filter(e => e)
					.concat(this.$router.options.routes)
					.filter(e => e.name === this.$options.name)[0]
					.path
					.replace(/:(.*)[?]*/, "")
			)
			.at(-1)

		coCode = coCode === this.$options.name || coCode.startsWith(location.origin) ? "www" : coCode

		$.ajax({
			url: this.APIs.OAUTH + '/naver',
			type: "POST",
			data: {
				url: 'https://nid.naver.com/oauth2.0/token?'
						+ 'grant_type=' + 'authorization_code' + '&'
						+ 'client_id=' + this.APIs.NAVER_LOGIN_KEY + '&'
						+ 'client_secret=' + this.APIs.NAVER_LOGIN_SECRET + '&'
						+ 'code=' + new URL(window.location.href).searchParams.get("code") + '&'
						+ 'state=' + new URL(window.location.href).searchParams.get("state"),
				naverClientId: this.APIs.NAVER_LOGIN_KEY,
				naverClientSecret: this.APIs.NAVER_LOGIN_SECRET
			},
			success: function (r) {
				// 네이버 이메일 추출
				let email = null;
				if (r.result && r.result.response && r.result.response.email) {
					email = r.result.response.email;
				}

				self.axiosCaller.get(self, self.APIs.SESSION + "/doSnsLogin", {
					snsService: "naver",
					snsId: r.result.response.id,
					email: email,
					deviceToken: (self.webUtils.isDom('#deviceToken')) ? document.querySelector('#deviceToken').value : "",
				}, async (res) => {

					const result = res.data;

					if (result.status === "ok") {
						if (await self.setSessionProc(result.coAccountVO)) {
							self.setSessionKeep(this.isKeepSession);
							
							// SSO 모드 확인 (세션 스토리지에서 SSO 파라미터 가져오기)
							let ssoParams = null;
							try {
								const ssoParamsStr = sessionStorage.getItem('ssoParams');
								if (ssoParamsStr) {
									ssoParams = JSON.parse(ssoParamsStr);
									sessionStorage.removeItem('ssoParams'); // 사용 후 삭제
								}
							} catch (e) {
								console.log("SSO 파라미터 확인 실패:", e);
							}

							// SSO 모드면 SSO 처리
							if (ssoParams) {
								self.axiosCaller.post(self, self.APIs.SESSION + "/doSSOSnsLogin", {
									uuid: ssoParams.uuid,
									gid: ssoParams.gid,
									redirecturl: ssoParams.redirecturl
								}, (ssoRes) => {
									const ssoResult = ssoRes.data;
									if (ssoResult.status === "ok") {
										// 팝업으로 열렸다면 부모 창으로 결과 전달
										if (window.opener && !window.opener.closed) {
											window.opener.postMessage({
												key: "sso_login_success",
												redirectUrl: ssoResult.redirectUrl,
												code: ssoResult.redirectUrl ? ssoResult.redirectUrl.split("code=")[1]?.split("&")[0] : null
											}, location.origin);
											self.$nextTick(() => {
												window.opener.focus();
												window.close();
											});
										} else {
											// 일반 페이지로 열렸다면 직접 리디렉션
											location.href = ssoResult.redirectUrl;
										}
									} else {
										if (window.opener && !window.opener.closed) {
											window.opener.postMessage({
												key: "sso_login_fail",
												msg: ssoResult.msg || "SSO 로그인에 실패했습니다."
											}, location.origin);
											self.$nextTick(() => {
												window.opener.focus();
												window.close();
											});
										} else {
											self.swalUtils.fireSsoLicenseAuthGuide(ssoResult.msg);
										}
									}
								});
							} else {
								// 일반 모드
								self.goWithCoCode(self);
							}
						}
					} else {
						if (window.opener) {
							window.opener.postMessage({
								"key": "alert",
								"icon": "info",
								"title": "Error",
								"content": result.msg
							}, location.origin.replace(webUtils.getSubdomainWithURLString(location.origin), coCode))
							vue.$nextTick(() => {
								close()
							})
						} else {
							vue.swalUtils.gritter("Error", result.msg, "question", 1500, () => {
								history.back()
							})
						}
					}
				})
			},
			error: function (e) {
				console.log(e)
			}
		})
	},
	mounted() {
		this.appDeviceToken("#deviceToken")
	},
	methods: {
		goReferrer() {
			if (!this.stringUtils.isEmpty(this.$route.query.referrer)) {
				console.log(this.$route.query.referrer)
				location.href = this.$route.query.referrer
			} else {
				location.href = "/"
			}
		},
	}
}

</script>

<style scoped>

</style>
